module.exports = __webpack_public_path__ + "static/media/koc_logo_color.b528cb47.png";